module.exports = __webpack_public_path__ + "img/signal_cellular_connected_no_internet_1_bar.632ead9e.svg";